import { StatelessComponent, useRef } from 'react'
import * as styles from 'components/features/pfm/DebtsPage/DebtsPage.css'
import AccountsRatesModuleContainer from 'components/features/pfm/AccountsRates/AccountsRatesContainer'
import AccountsDetailsModuleContainer from 'components/features/pfm/AccountsDetailsModule/AccountsDetailsModuleContainer'
import AccountsBreakdownModuleContainer from 'components/features/pfm/AccountsBreakdown/AccountsBreakdownModuleContainer'
import ModuleWrapper from 'components/features/pfm/ModuleWrapper/ModuleWrapper'
import { InternalPageProps } from 'interfaces/pages'
import Anchor from 'components/atoms/navigation/Anchor'
import PageFooterButton from 'components/atoms/buttons/PageFooterButton'
import TrendRankContainer from 'components/features/pfm/TrendRank/TrendRankContainer'
import { SingleColumnLayout } from 'components/layouts/Layouts'
import { createSeeAllCategoriesButton, useShouldShowPageParamsStickyHeader } from 'helpers/pageHelpers'
import InternalLayoutContainer from 'components/features/pfm/InternalLayout/InternalLayoutContainer'
import InternalSidebarContainer from 'components/features/pfm/InternalSidebar/InternalSidebarContainer'
import { PageParamsStickyHeader } from 'components/features/pfm/PageParamsHeader/PageParamsStickyHeader'
import { DesktopInternalStickyHeader } from 'components/features/pfm/DesktopInternalStickyHeader/DesktopInternalStickyHeader'
import { PageParamsHeader } from 'components/features/pfm/PageParamsHeader/PageParamsHeader'
import { NotificationTrayWrapper } from 'components/features/pfm/NotificationTray/NotificationTrayWrapper'
import { useSimpleGuard } from 'helpers/loadableHelpers'
import { linkedMixedAccountsGuard } from 'guards/linkageGuards'

const DebtsPage: StatelessComponent<InternalPageProps> = ({ timeframe, categoryId }) => {
  useSimpleGuard(linkedMixedAccountsGuard, {}, 'DebtsPage')

  const pageBody = (
    <>
      <TrendRankContainer type='debts' timeframe={ timeframe } categoryId={ categoryId } />

      <ModuleWrapper
        title={ <span>Breakdown by <span className={ styles.visibleSmallUp }>Account</span> Type</span> }
        anchor='debts_breakdown'
        card={ false }
        action={ createSeeAllCategoriesButton('debts_breakdown') }
      >
        <AccountsBreakdownModuleContainer type='debts' timeframe={ timeframe } />
      </ModuleWrapper>

      <ModuleWrapper
        title='Interest Rates'
        card={ false }
        anchor='debts_rates'
        action={ createSeeAllCategoriesButton('debts_rates') }
      >
        <AccountsRatesModuleContainer type='debts' timeframe={ timeframe } />
      </ModuleWrapper>

      <ModuleWrapper
        title='Account Details'
        card={ false }
        anchor='debts_details'
        action={ createSeeAllCategoriesButton('debts_details') }
      >
        <AccountsDetailsModuleContainer type='debts' categoryId={ categoryId } />
      </ModuleWrapper>

      <PageFooterButton text='See Your Assets' to='assets' />
    </>
  )

  const staticHeaderRef = useRef<HTMLDivElement>(null)
  const shouldShowStickyHeader = useShouldShowPageParamsStickyHeader(staticHeaderRef)

  const notifications = (
    <NotificationTrayWrapper
      renderLevel='page'
      placement='debts_general'
      isPositionRelative
    />
  )

  return (
    <InternalLayoutContainer
      sidebar={ <InternalSidebarContainer /> }
      notifications={ notifications }
      stickyHeader={ <PageParamsStickyHeader type='debts' /> }
      shouldShowStickyHeader={ shouldShowStickyHeader }
    >
      <Anchor placement='debts'>
        <Anchor placement='debts_general'>
          <DesktopInternalStickyHeader isShown={ shouldShowStickyHeader }>
            <PageParamsStickyHeader type='debts' />
          </DesktopInternalStickyHeader>
          <SingleColumnLayout
            header={ <PageParamsHeader type='debts' nodeRef={ staticHeaderRef } /> }
          >
            { pageBody }
          </SingleColumnLayout>
        </Anchor>
      </Anchor>
    </InternalLayoutContainer>
  )
}

export default DebtsPage
